import clsx from 'clsx'
import React from 'react'

import { Tooltip } from 'slab'

interface UnderlinedTooltipProps {
  content: React.ReactNode
  children: React.ReactNode
  className?: string
  onClick?: () => void
  enabled?: boolean
  withPortal?: boolean
}

export const UnderlinedTooltip: React.FC<UnderlinedTooltipProps> = ({
  content,
  children,
  className = '',
  onClick,
  enabled = true,
  withPortal = true,
}) => {
  const underlineClasses = 'cursor-help underline decoration-dotted hover:decoration-solid underline-offset-[0.25rem]'

  return (
    <Tooltip content={content} enabled={enabled} zIndex={20} withPortal={withPortal}>
      <div
        className={clsx(className, {
          [underlineClasses]: enabled,
        })} onClick={onClick}
      >
        {children}
      </div>
    </Tooltip>
  )
}
